module.exports = __webpack_public_path__ + "static/media/competitor.7483b7cb.svg";